import { useContext, useMemo } from 'react';
import { SnackbarContext } from './SnackbarContext';

export const useCreateSnackbar = () => {
  const { createSnackbar } = useContext(SnackbarContext);

  return useMemo(() => createSnackbar, [createSnackbar]);
};
